var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck_order",
    transform: "translate(-435 -327)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11087",
    "data-name": "Rectangle 11087",
    width: 94,
    height: 94,
    rx: 4,
    transform: "translate(435 327)",
    fill: "#9baebc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "local_shipping_black_24dp",
    transform: "translate(450 342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M0,0H64V64H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M50.333,14.667H43.667V9.333A5.349,5.349,0,0,0,38.333,4h-32A5.349,5.349,0,0,0,1,9.333v24a5.349,5.349,0,0,0,5.333,5.333,8,8,0,0,0,16,0h16a8,8,0,0,0,16,0H57A2.675,2.675,0,0,0,59.667,36V27.12a5.365,5.365,0,0,0-1.067-3.2l-6.133-8.187a2.7,2.7,0,0,0-2.133-1.067Zm-36,26.667A2.667,2.667,0,1,1,17,38.667,2.675,2.675,0,0,1,14.333,41.333Zm36-22.667,5.227,6.667H43.667V18.667Zm-4,22.667A2.667,2.667,0,1,1,49,38.667,2.675,2.675,0,0,1,46.333,41.333Z",
    transform: "translate(1.667 6.667)",
    fill: "#9baebc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckOrder);
export default __webpack_public_path__ + "static/media/truck_order.7bf9f30a723142d5ee2abf2eff1465e8.svg";
export { ForwardRef as ReactComponent };